<template>
  <div
    class="xl:w-4/5 md:w-11/12 xl:my-10 md:my-4
     md:mx-auto m-1 bg-gray-50 rounded"
  >
    <EditForm
      :row="Array(headings.length)"
      :headers="headings"
      :submitEdit="submitEdit"
      v-if="show"
    />
    <div class="flex flex-row justify-center p-4 w-full">
      <div class="flex ml-auto">
        <div>
          <h1 class="font-semibold xl:text-xl ">Manage Modules:</h1>
        </div>
        &nbsp;
        <div>
          <select
            name="Select Year"
            @change="handleSelected($event)"
            class=" xl:text-xl  "
          >
            <option
              :value="i"
              v-for="i in MAX_YEARS"
              v-bind:key="i.id"
              class="hover:border-orange-600"
              >Year {{ i }}</option
            >
          </select>
        </div>
      </div>
      <t-button
          variant="success"
          class="float-right ml-auto"
          @click="show = true"
          >Insert New Record</t-button
        >
        <br />
    </div>
    <div class="p-4 w-auto">
      <t-alert variant="info" show v-on:hidden="setCookie" v-if="noCookie()">
        mod_code: CSxxxx or IYxxxx <br />
        title: Full name of the module <br />
        strands: associate strands to each module, comma-separated.<br />
        crns: CRNs configured for the module, comma-separated.<br />
      </t-alert>
    </div>
    <div class="flex">
      <Table
        :items="items"
        :del="del"
        :edit="edit"
        :getTheDataInParent="getTheData"
      />
    </div>
  </div>
</template>

<script>
import Table from './Table';
import EditForm from './EditForm';

export default {
  components: {
    Table,
    EditForm,
  },
  mounted() {
    this.getTheData();
  },
  methods: {
    handleSelected(event) {
      this.year = event.target.value;
      this.getTheData();
    },
    async getTheData() {
      const res = await fetch(
        `${process.env.VUE_APP_API_URL}/get_modules`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            year: this.year,
            jwt: localStorage.getItem('jwt'),
          })
        },
      );
      const ret = await res.json();
      if (!ret.success) {
        throw res.error;
      }
      this.items = ret.data;
      this.getHeadings();
    },
    async del(row) {
      const res = await fetch(
        `${process.env.VUE_APP_API_URL}/delete_module_record`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            row: row,
            jwt: localStorage.getItem('jwt'),
          }),
        },
      );
      return await res;
    },
    async edit(oldRow, newRow) {
      const res = fetch(
        `${process.env.VUE_APP_API_URL}/edit_module_row`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            oldRow: oldRow,
            newRow: newRow,
            jwt: localStorage.getItem('jwt'),
          }),
        },
      );
      return await res;
    },

    getHeadings: function() {
      try {
        const i = Object.keys(this.items).map((key) => {
          return [Number(key), this.items[key]];
        });

        this.headings = Object.keys(i[0][1]);
        console.log(this.headings);
      } catch (_e) {}
    },

    submitEdit(edit) {
      if (edit === 'cancel') {
        this.show = false;
        return;
      }

      console.log(edit);
      this.show = false;

      this.insert(edit).then((res) => {
        if (res.ok) {
          console.log(res);
          this.$vToastify.success('Successfully carried out edit');
          this.getTheData();
        } else {
          this.$vToastify.error('Could not edit, see console for details');
          console.error(res);
        }
      });
    },

    async insert(edit) {
      const res = fetch(
        `${process.env.VUE_APP_API_URL}/insert_module_row`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            edit: edit,
            jwt: localStorage.getItem('jwt'),
          }),
        },
      );
      return await res;
    },

    setCookie() {
      this.$cookies.set('ManageModules-infobox', 'dismissed', 'infinity');
    },
    noCookie() {
      return !(this.$cookies.get('ManageModules-infobox') === 'dismissed');
    },
  },
  data() {
    return {
      headings: [],
      show: false,
      items: [],
      year: 1,
      MAX_YEARS: 4,
    };
  },
};
</script>

<style></style>
